import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { refreshAuthUser, useAuthToken } from "../api/adminApi";

const ProtectedRoute = ({ children }) => {
  const token = useAuthToken();
  const [readyToken, setReadyToken] = useState(null);
  useEffect(() => {
    if (!token) return;
    let active = true;
    refreshAuthUser().catch(() => {}).finally(() => { if (active) setReadyToken(token); });
    return () => { active = false; };
  }, [token]);
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  if (readyToken !== token) return <div className="page-loading"><p>Checking access…</p></div>;
  return children;
};

export default ProtectedRoute;
